import { Link, useNavigate } from 'react-router-dom'
import { PageChrome, ROUTES, useIsDesktop } from '@/components/gg/chrome'
import { PhoneFeed, TunedLine } from '@/components/feed/PhoneFeed'
import { DeskFeed } from '@/components/feed/DeskFeed'
import { useNewsletterItems } from '@/hooks/useNewsletterItems'
import { useFeedData, useFeedTuned } from '@/hooks/useFeed'
import '@/styles/feed.css'

/**
 * Your feed (/app). Root tab.
 *
 * Brian's headlines.html v7.1 on the phone: no large "Your feed"; the title's
 * row holds "Tuned for …" and the Tune button, then the tall cards grouped by
 * day. His desk.html v1.5 on a computer: the toolbar reads Your feed, then
 * "Bend · 2 built" and This week's newsletter with its count; the list with
 * the chosen story open beside it.
 */
export function FeedPage() {
  const desktop = useIsDesktop()
  const navigate = useNavigate()
  const nl = useNewsletterItems()
  const { data } = useFeedData()
  const tuned = useFeedTuned()
  const built = data ? data.stories.size : 0
  return (
    <>
      <PageChrome
        title="Your feed"
        navKey="feed"
        actions={desktop ? (
          <>
            {tuned.home && <span className="dfeed-tsub">{tuned.home.split(',')[0]} · {built} built</span>}
            <Link className="gg-act" to={ROUTES.newsletter}>This week’s newsletter <span className="dfeed-nlpill">{nl.items.length}</span></Link>
          </>
        ) : <TunedLine onOpen={() => navigate(ROUTES.feedControls)} />}
      />
      {desktop ? <DeskFeed /> : <PhoneFeed />}
    </>
  )
}
